import React from "react";
import { SizeSelectFieldSize } from "./SizeSelectField";

export interface SizeSelectInputProps {
  sizes: SizeSelectFieldSize[];
  selectedSizeIds: Set<string>;
  focused?: boolean;
  onClick?: () => void;
}

export class SizeSelectInput extends React.Component<SizeSelectInputProps, {}> {
  static defaultProps = {
    focused: false
  };

  constructor(props: SizeSelectInputProps) {
    super(props);
  }

  render() {
    return (
      <>
        <div
          className={`t-size-select-input c-new-size-select-field__input text-field text-field--new-style ${this.props
            .focused && "text-field--new-style-focused"}`}
          onClick={this.props.onClick}
          data-testid="size-select-input"
        >
          <input
            type="text"
            className="c-new-size-select-field__hidden-native-input t-size-select-native-input"
            name="size"
            onFocus={e => this.onNativeInputFocus(e)}
          />
          {this.selectedSizes().map((size: SizeSelectFieldSize) => (
            <span key={size.sizeId} className="c-new-size-select-field__selected-size-label">
              {size.label}
              <input
                type="checkbox"
                className="u-hide js-filter-value"
                value={size.sizeId}
                data-attribute="size"
                checked={true}
                readOnly={true}
              />
            </span>
          ))}
        </div>
        {this.renderDomNodesMimickingCheckboxFilters()}
      </>
    );
  }

  renderDomNodesMimickingCheckboxFilters() {
    return (
      <dl className="u-hide t-size-select-input-dom">
        <dt>
          <a>Size</a>
        </dt>
        <dd>
          <ol>
            {this.selectedSizes().map((size: SizeSelectFieldSize) => (
              <li key={size.sizeId}>
                <label>
                  <input
                    type="checkbox"
                    className="js-filter-value"
                    value={size.sizeId}
                    data-attribute="size"
                    checked={true}
                    readOnly={true}
                  />
                  <span className="js-filter-label">{size.label}</span>
                </label>
              </li>
            ))}
          </ol>
          <input
            type="hidden"
            name="size"
            id="size"
            value={this.selectedSizes()
              .map(s => s.sizeId)
              .join("/")}
            className="js-filter-values"
          />
        </dd>
      </dl>
    );
  }

  selectedSizes(): SizeSelectFieldSize[] {
    return this.props.sizes.filter(size => this.props.selectedSizeIds.has(size.sizeId));
  }

  onNativeInputFocus(event: any) {
    event.target.blur();

    if (this.props.onClick) {
      this.props.onClick();
    }
  }
}
